'use strict';

customerZone.run(['$rootScope', 'Session', 'salesAnalytics', function($rootScope, Session, salesAnalytics){
    $rootScope.$on(Session.PROFILE_CHANGED_EVENT, function(){
        if (Session.authenticated())
            salesAnalytics.signalEvent('login');
        else
            salesAnalytics.signalEvent('logout');
    });

    $rootScope.$on('$routeChangeSuccess', function(event, toRoute){
        salesAnalytics.signalRouteChange(toRoute.originalPath);
    });

}]);
